import React from 'react'

const SEO = ({ title, description, pathname, children, ogimage, url }) => {

  const seo = {
    title: title || 'TGI Fridays',
    description: description || 'TGI Fridays serves up your favorite American food dishes right off the grill. Over 931 restaurant bar and grills in 60+ countries. Find a location near you!',
    image: ogimage || 'https://d1hrv70810iaxk.cloudfront.net/images/chris-test-41/find-us-header', 
    url: 'https://www.tgifridays.com.au/' + url || `https://www.tgifridays.com.au/`
    }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="title" content={seo.title} />
      <meta name="og:title" content={seo.title} />
      <meta name="description" content={seo.description} />
      <meta name="og:description" content={seo.description} />
      <meta name="og:image" content={seo.image} />
      <meta name="canonical_url" content={seo.url} />
      <meta name="og:url" content={seo.url} />
      {children}
    </>
  )
}

export default SEO
